import { rem } from 'polished'
import React from 'react'
import cn from 'clsx'
import styled from 'styled-components'
import { useCruiseSearchEnabled } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalCruisesSearch'
import CruiseSearchHeroContainer from 'components/Search/Cruise/CruiseSearchHeroContainer'
import CruiseSearchContainerPane, { CruiseSearchContainerPaneContent } from 'components/Search/Cruise/CruiseSearchContainerPane'
import { CRUISE_SEARCH_HERO_IMAGE_ID, CRUISE_SEARCH_HERO_VIDEO_URL, CRUISE_SEARCH_HERO_BAR_DESTINATIONS } from 'constants/cruise'
import GlobalMobileSearchHeroBar from 'components/SearchV2/Components/Mobile/GlobalMobileSearchHeroBar'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'components/Luxkit/Typography/Heading'
import TextButton from 'components/Luxkit/Button/TextButton'
import Group from 'components/utils/Group'
import CruiseSearchFiltersBar from '../SearchPage/Filters/CruiseSearchFiltersBar'

const CruisesVideoContainer = styled.div`
  height: ${rem(350)};
  position: relative;

  ${mediaQueryUp.tablet} {
    height: ${rem(400)};
  }
`

const CruisesVideoBanner = styled.video`
  height: 100%;
  width: 100%;
  object-fit: cover;
`

const BannerText = styled(LayoutContainer)`
  position: absolute;
  height: 100%;
  width: 100%;
  inset: 0;
  top: 0;
  left: 0;
`

const LayoutContainerSearchBarMobile = styled(LayoutContainer)`
  position: absolute;
  bottom: 0;
  transform:translateY(50%);

  &.float-search-bar {
    position: relative;
    transform: unset;
    margin-top: ${rem(16)};
  }
`

interface Props {
  floatingSearchBar?: boolean
}

function CruisePageSearchHero({ floatingSearchBar } : Props) {
  const isCruiseSearchEnabled = useCruiseSearchEnabled()

  return <>
    {isCruiseSearchEnabled && <CruiseSearchHeroContainer
      heroImageId={CRUISE_SEARCH_HERO_IMAGE_ID}
      title={<><i>Cruise</i> into your perfect getaway</>}
      subtitle="Choose from our various cruises tailored to your taste."
      gravity="center"
      aspectRatio="16:9"
      floatingSearchBar={floatingSearchBar}
    >
      <CruiseSearchContainerPane floatingSearchBar={floatingSearchBar}>
        <CruiseSearchContainerPaneContent>
          <CruiseSearchFiltersBar />
        </CruiseSearchContainerPaneContent>
      </CruiseSearchContainerPane>

      <LayoutContainerSearchBarMobile className={cn({ 'float-search-bar': floatingSearchBar })}>
        <GlobalMobileSearchHeroBar
          placeholder="Search cruises to"
          placeholderTextList={CRUISE_SEARCH_HERO_BAR_DESTINATIONS}
        />
      </LayoutContainerSearchBarMobile>
    </CruiseSearchHeroContainer>}

    {!isCruiseSearchEnabled && <CruisesVideoContainer>
      <CruisesVideoBanner
        controls={false}
        autoPlay
        playsInline
        loop
        muted
      >
        <source src={CRUISE_SEARCH_HERO_VIDEO_URL} type="video/mp4" />
      </CruisesVideoBanner>
      <BannerText>
        <Group
          direction="vertical"
          verticalAlign="center"
          horizontalAlign="start"
          gap={24}
          fullHeight
        >
          <Heading variant="heading1" colour="neutral-eight">
            Cruises
          </Heading>
          <Heading variant="heading3alt" colour="neutral-eight">
            Explore the world's best cruises
          </Heading>
          <TextButton kind="secondary" variant="ghost" href="#listings">
            Browse all offers
          </TextButton>
        </Group>
      </BannerText>
    </CruisesVideoContainer>}
  </>
}

export default CruisePageSearchHero
